// import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
//import 'react-app-polyfill/stable';
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Link, useLocation } from "react-router-dom";
import { ThreeDots } from './ThreeDots';
import './DplayActivate.css';
import Axios from 'axios';
import { Button, TextField, Typography } from '@material-ui/core';
import { Paper } from '@material-ui/core';
import Image from './images/sappa_background.jpg';
import { Drawer } from '@material-ui/core';
import { GetData } from './SkyShowTimeActication';
const defaultUrl = "https://signup.viaplay.se/sappa?key1=16&key2=&emailToken=";

const styles = {
  paperContainer: {
    backgroundImage: `url(${Image})`,
    height: '1920vh',
    width: '1080vh'
  }
};


function SappaPlayActivate(props) {

  const [loading, setLoading] = React.useState();
  const [showInput, setShowInput] = React.useState();
  const [activationCode, setActivationCode] = React.useState();
  const [email, setEmail] = React.useState();
  const [password, setPassword] = React.useState();
  const [errMsg, setErrMsg] = React.useState();
  const [responseOk, setResponseOk] = React.useState();

  useEffect(() => {
      setShowInput(false);

      const windowUrl = window.location.search;
      let code =   window.location.pathname.replace('/sappaplay','');
      code=code.replace('/','');
      setActivationCode(code);

  }, []);


  return (

    <div style={{ backgroundImage: `url(${Image})`, height: '100vh', width: '85vw', backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
      <div style={{ width: "1000px" }}>
        <Drawer
          anchor={"right"}
          open={true}
          width={"1000px"}
          variant={"permanent"}
        >
          <div style={{ width: '20vw' }} />

          <center><img src={require('./images/Sappa_Play_Green.png')} style={{  marginTop: '20px',marginBottom:'20px' }} /></center>

          <h4 style={{ margin: "10px", fontFamily:'arial' }}>Välkommen att logga in på din enhet med Sappa Play</h4>
          <div style={{  marginLeft: '10px', alignSelf: 'flex-start', marginRight: '10px', fontFamily:'arial' }}>
            Om aktiveringskoden inte är ifylld automatiskt behöver du ange denna.</div>
          <div style={{  marginLeft: '10px', alignSelf: 'flex-start', marginRight: '10px', marginBottom: '20px',fontFamily:'arial' }}>Klicka sedan på Fortsätt och ange dina inloggningsuppgifter för Sappa Play.</div>
          
          {!showInput && <TextField size='medium' value={activationCode} defaultValue={activationCode} onChange={(e) => setActivationCode(e.target.value)} id="activationCode" label="Aktiveringskod" variant="outlined" style={{ margin: "10px" }} />}
          {showInput && <TextField value={email} defaultValue='' onChange={(e) => setEmail(e.target.value)} id="email" label="E-post" variant="outlined" style={{ marginLeft: "10px", marginRight: "10px", marginBottom: "10px" }} />}
          {showInput && <TextField value={password} defaultValue='' onChange={(e) => setPassword(e.target.value)} id="zipcode" label="Lösenord" variant="outlined" style={{ marginLeft: "10px", marginRight: "10px", marginBottom: "10px" }} />}

          <div>
            <Button
              size='medium'
              variant='contained'
              disabled={loading}
              style={{ margin: "10px",color:'003b4a'}}
              onClick={() => {

                if (activationCode==null || activationCode=='') {
                  setErrMsg("Du måste ange en aktiveringskod.");
                  return;
                }

                // setLoading(true);
                // setErrMsg("");
                // setResponseOk(false);
                // //alert("Activate Customer: " + customerNo + " ZipCode: " + zipCode);

                // let endpoint = 'https://skyshowtime.sappa.se/api/activation?customerNo=' + customerNo + '&zipCode=' + zipCode;

                // fetch(endpoint, { method: 'POST', headers: { Authorization: '14CB411572204EA39CA067D3A0CCF816' } })
                //   .then(response => {
                //     setResponseOk(true);
                //     return response.json();
                //   })
                //   .then(data => {
                //     console.log(data);
                //     if (data.Message.length > 0) {
                //       setErrMsg(data.Message);
                //     }
                //     else {
                //       if (data.ActivationUrl.length > 0 && data.HasEntitlement && data.Verified) {
                //         window.location.href = data.ActivationUrl;
                //       }
                //     }
                //     setLoading(false);
                //   })
                //   .catch(
                //     exp => {
                //       setLoading(false);
                //       console.log(exp);
                //     }
                //   );

                setShowInput(true);

              }}>Aktivera</Button>
            <Button size='medium' variant='contained' color='default' style={{ margin: "10px" }} href='/'>Avbryt</Button>
            {/* {ShowLoading(loading)} */}
          </div>
          <div style={{ color: 'red', margin: "10px" }}>{errMsg} </div>
        </Drawer>
      </div>
    </div>
  );
}

export default SappaPlayActivate;
